import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDropdownIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 8,
	viewBox: "0 0 12 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.59 0.589844L6 5.16984L1.41 0.589844L0 1.99984L6 7.99984L12 1.99984L10.59 0.589844Z",
		fill: "#E8EAED"
	})
});
export { SvgDropdownIcon as ReactComponent };
